// extracted by mini-css-extract-plugin
module.exports = {"formItem":"setting-form_formItem_220Ho","numberInput":"setting-form_numberInput_k8Hb0","unit":"setting-form_unit_2Espi"};